import { BrowserRouter, Route, Routes } from 'react-router-dom'
import MainLayout from './components/layout/MainLayout'
import { routes } from './routes'
import { Login } from './pages/login/Login'
import { EmailConfirmation } from './pages/login/EmailConfirmation'
import { AuthHandler } from './pages/login/AuthHandler'
import Progress from './pages/similarity/Progress'
import UserDetailContextProvider from "./context/UserDetailContext";

function App() {
  return (
      <UserDetailContextProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/verify-email/:actToken" element={<EmailConfirmation />} />
            <Route path="/user/oauth2/redirect" element={<AuthHandler />}></Route>
            <Route path="/progress" element={<Progress />}></Route>
            <Route path="/" element={<MainLayout />}>
              {routes}
            </Route>
          </Routes>
        </BrowserRouter>
      </UserDetailContextProvider>
  )
}

export default App
